import { useState } from "react"
import { Button, Card, Grid, TextField, IconButton, CardHeader, CardContent, Typography } from "@material-ui/core"
import { EditTwoTone as EditIcon } from '@ant-design/icons';
import { Field, Form, Formik } from "formik";
import { ErrorPop } from "components/ErrorPop"

export const Locale = ({ tenant }) => {
    const [notice, setNotice] = useState(null)

    const Location = ({ location: initialLocation }) => {
        const [edit, setEdit] = useState(false)
        const [location, setLocation] = useState(initialLocation)

        const save = (fields) => {
            setLocation(fields)
            setEdit(false)
            setNotice('Location updated locally. No server save API exists yet — changes are not persisted.')
        }

        return (
            <Card elevation={8} style={{ margin: '1em', padding: "1em" }} >
                <CardHeader
                    title={location.id}
                    action={
                        <IconButton aria-label="settings" onClick={() => setEdit(!edit)}>
                            <EditIcon size="sm"/>
                        </IconButton>
                    }
                />
                <CardContent>
                    {edit ? (
                        <Formik initialValues={location} onSubmit={save} enableReinitialize>
                            <Form>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Field as={TextField} fullWidth variant="outlined" label="Destination" name="Destination" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field as={TextField} fullWidth variant="outlined" label="Region" name="Region" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field as={TextField} fullWidth variant="outlined" label="id" name="id" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field as={TextField} fullWidth variant="outlined" label="Language" name="Language" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field as={TextField} fullWidth variant="outlined" label="Location" name="Location" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button variant="contained" color="primary" type="submit">Save</Button>
                                        <Button variant="text" onClick={() => setEdit(false)} style={{ marginLeft: 8 }}>Cancel</Button>
                                    </Grid>
                                </Grid>
                            </Form>
                        </Formik>
                    ) : (
                        <table style={{ width: "100%" }}>
                            <tbody>
                                <tr><td style={{ textAlign: "right" }}>Destination:</td>
                                <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{location.Destination}</td></tr>
                                <tr><td style={{ textAlign: "right" }}>Region:</td><td>{location.Region}</td></tr>
                                <tr><td style={{ textAlign: "right" }}>id:</td><td>{location.id}</td></tr>
                                <tr><td style={{ textAlign: "right" }}>Language:</td><td>{location.Language}</td></tr>
                                <tr><td style={{ textAlign: "right" }}>Location:</td><td>{location.Location}</td></tr>
                            </tbody>
                        </table>
                    )}
                </CardContent>
            </Card>
        )
    }

    return (
        <>
            <Grid container>
                {tenant?.tenant_details?.locations?.map(location => (
                    <Grid key={location.id} item xs={12} md={4} style={{ padding: '1em' }}>
                        <Location location={location} />
                    </Grid>
                ))}
                {!tenant?.tenant_details?.locations?.length && (
                    <Grid item xs={12}>
                        <Typography color="textSecondary">No locations configured.</Typography>
                    </Grid>
                )}
            </Grid>
            <ErrorPop error={notice} setError={setNotice} timeout={8000} />
        </>
    )
}
